import { FSA } from 'flux-standard-action';

export enum ConfigurationPanelsActionTypes {
  Toggle = '@configurationPanels/toggle',
  Show = '@configurationPanels/show',
  Hide = '@configurationPanels/hide',
}

export const configurationPanels = {
  toggle: (): FSA<ConfigurationPanelsActionTypes.Toggle, boolean> => ({
    type: ConfigurationPanelsActionTypes.Toggle
  }),
  show: (): FSA<ConfigurationPanelsActionTypes.Show, boolean> => ({
    type: ConfigurationPanelsActionTypes.Show
  }),
  hide: (): FSA<ConfigurationPanelsActionTypes.Hide, boolean> => ({
    type: ConfigurationPanelsActionTypes.Hide
  })
};